import { PresenceLogoutTrigger } from 'src/core/presence/domain/lost-changes-report';

export class ReportLostChangesRequest {
  constructor(public readonly trigger: PresenceLogoutTrigger) {}
}
